angular.module('website').controller('website.newProspectCtrl', ["$scope", "$http", "$timeout", "FormFieldDisplayingService", "DataService", function($scope, $http, $timeout, FormFieldDisplayingService, DataService) {
  var clearErrors, loadForms, setLinksTarget;
  $scope.gym = {
    currency_symbol: DataService.currency,
    units: DataService.units
  };
  $scope.pixelId = DataService.gym_config.facebook_pixel_id_for_contact_us_page;
  $scope.pixelEvent = DataService.gym_config.facebook_pixel_event_for_contact_us_page;
  $scope.gtmId = DataService.gym_config.gtm_code_for_contact_us_page;
  $scope.recaptchaKey = DataService.recaptcha_site_key;
  $scope.contactType = 'prospect';
  $scope.showFormField = function(field) {
    return FormFieldDisplayingService.isDisplaying($scope.contactType, field);
  };
  $http.get(`/gyms/${DataService.gym_id}/privacy_policies?filters[policy_context]=gym_website`).then(function(response) {
    $scope.privacyPolicies = response.data.collection;
    $scope.editContact.privacy_policy_responses_attributes = $scope.privacyPolicies ? $scope.privacyPolicies.map(function(item) {
      return {
        privacy_policy_id: item.id,
        accepted: false
      };
    }) : [];
    return setLinksTarget();
  });
  setLinksTarget = function() {
    return $timeout(function() {
      return angular.element('.form-group a').each(function(i, element) {
        return element.target = '_blank';
      });
    });
  };
  $scope.editContact = {
    contact_information: {}
  };
  clearErrors = function() {
    return _.each($scope.forms, function(form) {
      return $scope.editContact[form.name] = {
        errors: {}
      };
    });
  };
  loadForms = function() {
    var url;
    url = `/gyms/${DataService.gym_id}/forms?contact_type=prospects`;
    return $http.get(url).then(function(response) {
      $scope.forms = _.filter(response.data, function(form) {
        return form.show_on_new_record && form.on_website && !form.archived;
      });
      return clearErrors();
    });
  };
  loadForms();
  $scope.isFormInvalid = function() {
    return _.find($scope.forms, function(form) {
      return form.on_website && _.find(form.fields, function(field) {
        var isRequired;
        isRequired = field.customizable_required_settings ? field.required_on_website : field.required;
        return field.on_prospect && field.on_website && isRequired && !field.archived && !$scope.editContact[form.name][field.name];
      });
    });
  };
  $scope.submitForm = function() {
    $scope.errorMessage = "";
    $scope.saveVisible = false;
    if ($scope.recaptchaKey) {
      return $scope.$emit('recaptcha:execute');
    } else {
      return $scope.save();
    }
  };
  $scope.onRecaptchaError = function() {
    $scope.errorMessage = "Sorry, there seems to be an issue with the reCAPTCHA service. Please try to submit your request again.";
    return $scope.saveVisible = true;
  };
  $scope.saveVisible = true;
  $scope.isSaved = false;
  return $scope.save = function(token) {
    var params;
    params = {
      contact: $scope.editContact,
      recaptcha_token: token
    };
    return $http.post(`/websites/${DataService.domain}/prospects`, params).then(function(response) {
      clearErrors();
      $scope.isSaved = true;
      return $timeout(function() {
        if (window.dataLayer) {
          return window.dataLayer.push({
            event: 'formSubmit'
          });
        }
      }, 500);
    }, function(response) {
      $scope.editContact.errors = response.data.errors;
      $scope.errorMessage = "Please ensure that your email is correct and that you've filled out the required fields";
      return $scope.saveVisible = true;
    });
  };
}]);
